import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStateInitial = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.29 3.16394C11.4195 2.94535 12.5805 2.94535 13.71 3.16394M13.71 20.8361C12.5805 21.0546 11.4195 21.0546 10.29 20.8361M17.048 4.54902C18.0033 5.19631 18.8252 6.02128 19.469 6.97898M3.16394 13.71C2.94535 12.5805 2.94535 11.4195 3.16394 10.29M19.451 17.048C18.8037 18.0033 17.9787 18.8252 17.021 19.469M20.8361 10.29C21.0546 11.4195 21.0546 12.5805 20.8361 13.71M4.54902 6.95198C5.19631 5.99667 6.02128 5.17476 6.97898 4.53102M6.95198 19.451C5.99667 18.8037 5.17476 17.9787 4.53102 17.021",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgStateInitial);
export { ForwardRef as ReactComponent };
